import { heartbeatRecieved } from '../redux/heartbeat';
import { 
    socketConnected, 
    socketDisconnected, 
    socketReconnected,
  } from '../redux/socket';
import { 
    offersReceived, 
    endingUpdated,
    propertyStarted,
    propertyEnded,
  } from '../redux/property';
import { 
    propertyStarted as developmentPropertyStarted, 
    propertyEnded as developmentPropertyEnded,
    propertyEndingUpdated,
  } from '../redux/development';

let socket;

export const SOCKET_EMIT = 'socket/SOCKET_EMIT';

const messageQueue = [];

const processMessageQueue = () => {
  try {
    // Open state
    if (socket.readyState === 1 && messageQueue.length > 0) {
      const message = messageQueue[0];
      socket.send(message);
      messageQueue.shift();
      processMessageQueue();
    }
  } catch (e) {
  }
}

const sendMessage = (subject, details) => {
  messageQueue.push(JSON.stringify({ subject, details }));
  processMessageQueue();
}

export function socketMiddleware() {
  return next => (action) => {
    const result = next(action);

    if (socket && action.type === SOCKET_EMIT) {
      const { subject, details } = action.payload;
      sendMessage(subject, details);
    }

    return result;
  };
}

const unpackSocketMessage = (message) => {
  try {
    if (!message || !message.subject || !message.details) {
      throw new Error('Invalid socket message');
    }

    // This should be identical to the input, but just in case,
    // we will remove any extra data incorrectly added

    return {
      subject: message.subject,
      details: message.details,
    };
  }
  catch(e) {
    console.error(e);
    return false;
  }
};

const handlePropertyRoomMessage = ({ dispatch }, room, message) => {
  const { subject = '', details } = unpackSocketMessage(message);

  switch (subject) {
    case 'offers_received': return dispatch(offersReceived(room, details));
    case 'property_ending': return dispatch(endingUpdated(room, details));
    case 'property_started': return dispatch(propertyStarted(room, details));
    case 'property_ended': return dispatch(propertyEnded(room, details));
    default: return;
  }
};

const handleDevelopmentRoomMessage = ({ dispatch }, room, message) => {
  const { subject = '', details } = unpackSocketMessage(message);

  switch (subject) {
    case 'property_started': return dispatch(developmentPropertyStarted(details));
    case 'property_ending': return dispatch(propertyEndingUpdated(room, details));
    case 'property_ended': return dispatch(developmentPropertyEnded(details));
    default: return;
  }
};

const handleGeneralMessage = ({ dispatch }, subject, details) => {
  switch (subject) {
    case 'heartbeat': return dispatch(heartbeatRecieved(details));
    default: return;
  }
};

const isPropertyRoom = (subject) => 
  subject.includes('-') && subject.split('-')[0] === 'property';

const isDevelopmentRoom = (subject) => 
  subject.includes('-') && subject.split('-')[0] === 'development';

const handleIncoming = (store, message) => {
  const { subject, details = '' } = message;
  if (isPropertyRoom(subject)) {
    const room = subject.split('-')[1];
    return handlePropertyRoomMessage(store, room, details);
  } else if (isDevelopmentRoom(subject)) {
    const room = subject.split('-')[1];
    return handleDevelopmentRoomMessage(store, room, details);
  } else {
    return handleGeneralMessage(store, subject, details);
  }
};

const receiveSocketData = (data) =>
  data.isTrusted && data.data && unpackSocketMessage(JSON.parse(data.data));

const connect = (address, store) => {
  const { dispatch, getState } = store;
  const { token = '' } = getState().auth;

  socket = new WebSocket(address);

  if (!socket) {
    setTimeout(() => connect(address, store), 2000);
    return;
  }

  socket.addEventListener('close', () => {
    socket = null;
    dispatch(socketDisconnected());
    setTimeout(() => connect(address, store), 2000);
  });

  socket.addEventListener('open', () => {
    processMessageQueue();
    dispatch(socketConnected());
    dispatch(socketReconnected(token));
  });

  socket.addEventListener('message', (data) => {
    const message = receiveSocketData(data);
    handleIncoming(store, message);
  });
}

export function joinRoom(room) {
  if (!socket) {
    console.error('Not connected to socket server - join room', room);
    return;
  }
  sendMessage('join_room', { room });
};

export function leaveRoom(room) {
  if (!socket) {
    console.error('Not connected to socket server - leave room', room);
    return;
  }
  sendMessage('leave_room', { room });
};

export default function startSocket(store) {
  // Connect the socket.
  connect(process.env.REACT_APP_WEBSOCKET_URL, store);
}



// WEBPACK FOOTER //
// ./src/middleware/socket.js